import type { IconSvgObject } from './types';

const CircleChevronRightIcon: IconSvgObject = [
  ["path", { d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10.25 8L12.7739 10.5858C13.4246 11.2525 13.75 11.5858 13.75 12C13.75 12.4142 13.4246 12.7475 12.7739 13.4142L10.25 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CircleChevronRightIcon;
